import React from 'react'
import { SalesContext } from 'src/Context/SalesContext';
import Footer from 'src/UI/NewPlanDetails/components/Footer';
import LetsConnect from 'src/Components/Common/Svg/LetsConnect';
import './CustomerFalloutScreen.css'
import { tagOnSuccessPageLoad } from 'src/Tagging/NewCustomerTagging';

const CustomerFalloutScreen = () => {

  const context = React.useContext(SalesContext);

  const goHome = () =>{

    window.location.href = '/vodacom/fibre/sales/leads';
  }

  React.useEffect(() => {

    tagOnSuccessPageLoad(
      context.userDetails.referenceNo || context.userDetails.quoteNumber,
      'NC Lead success',
      context.userDetails.contactNumber
    );
  }, [])
  
  return (

    <div className="customerfallout-main">

      <div className="customerfallout-container">

        <LetsConnect />

        <h2 className="customerfallout-heading">Let's get connected!</h2>

        <p className="customerfallout-text">
          Thanks for your interest in getting connected with our fibre plans. We
          can't wait to get you set up with lightning-fast internet.
        </p>

        <hr className="customerfallout-text-divider" />

        <p className="customerfallout-text">
          A friendly sales agent will be in touch shortly to discuss your chosen plan and finalise your order.
        </p>

        <hr className="customerfallout-divider" />

        <div className="customerfallout-details-container">

          <div className="customerfallout-detail">

            <p className="customerfallout-text">
              An email with more details has been sent to:
            </p>
            
            <p className="customerfallout-details">
              { context.userDetails.email }
            </p>

          </div>

          { context.userDetails.referenceNo || context.userDetails.quoteNumber
              
            ? <div className="customerfallout-detail">

                <p className="customerfallout-text">Your reference number is:</p>

                <p className="customerfallout-details">
                  { context.userDetails.referenceNo || context.userDetails.quoteNumber }
                </p>

              </div>
            : null
          }

        </div>
      </div>

      <Footer />

      <div className="customerfallout-btn-container">

        <button className="customerfallout-home-btn" onClick={goHome}>
          Go to home page
        </button>
  
      </div>
    </div>
  );
}

export default CustomerFalloutScreen;